import React, { useState, useEffect } from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import { getResources } from 'utils/ResourcesUtils';
import AssignRecipientsList from 'components/Resources/IDRRouting/AssignRecipientsList';
import { useAppContext } from 'hooks/useAppContext';
import CenteredCircularProgress from 'components/Shared/CenteredCircularProgress';
import CenteredError from 'components/Shared/CenteredError';


const SelectResource = () => {
  // local state object to refresh the component when updated;
  const [refresh, setRefresh] = useState(new Date());
  // local state datastore to hold resources after fetching.
  const [resources, setResources] = useState([]);
  // local state string to store selectedResource guid after a user selects;
  const [selectedResource, setSelectedResource] = useState(null);
  const [loadings, setLoadings] = useState({ resources: true });
  const [error, setError] = useState({ resources: false });
  const { selectedProject } = useAppContext();

  useEffect(() => {
    async function asyncEffect(projectId) {
      const data = await getResources(undefined, undefined, undefined, undefined, undefined, [{ defaults: { projectId, IsActive: true } }]);
      if (data.data) {
        setResources(data.data);
        setLoadings(old => ({ ...old, resources: false }));
        setError(old => ({ ...old, resources: false }));
      } else {
        setError(old => ({ ...old, resources: 'Error loading list.' }));
      }
    }

    asyncEffect(selectedProject);
  }, [selectedProject, refresh])

  const handleSelectResource = (event, child) => {
    setSelectedResource(child.props.value);
  };

  const refreshResources = async () => {
    setLoadings(old => ({ ...old, resources: true }));
    setError(old => ({ ...old, resources: false }));
    await new Promise(resolve => setTimeout(() => { resolve() }, 1000));
    setRefresh(new Date());
  }

  const renderSelect = () => (
    !loadings.resources ?
      <TextField select variant="outlined" label="Resource" defaultValue='' onChange={handleSelectResource} data-testid="select">
        {resources.map(r => (
          <MenuItem key={r.RassignmentId} value={r.RassignmentId}>{r.Name_SystemUser}</MenuItem>
        ))}
      </TextField>
      :
      !error.resources ? <CenteredCircularProgress /> : <CenteredError refresh={refreshResources} />
  );

  return (
    <>
      {renderSelect()}
      <AssignRecipientsList parentRAssignmentId={selectedResource} />
    </>
  )
}

export default SelectResource;